import { v4 as uuidv4 } from 'uuid';

import { db } from '../firebase/config';
import { doc, setDoc, Timestamp } from 'firebase/firestore';

const TORONTO_KIOSK_ID = `USD39Y001578`;
const VANCOUVER_KIOSK_ID = `USD3C0000774`;

const NUM_OF_QUESTIONS = 10;
const PRIZE_DAILY_LIMIT = 50;

const getAllAnswers = (totalQuestionNum = NUM_OF_QUESTIONS) => {
  const answers = {};
  for (let i = 0; i < totalQuestionNum; i++) {
    answers[`q_${i + 1}`] = localStorage.getItem(`question_${i + 1}`);
  }

  return answers;
};

const getCorrectAnswers = () =>
  localStorage.getItem('user-answers') ? JSON.parse(localStorage.getItem('user-answers')).filter(Boolean).length : null;

const removeAllAnswers = (totalQuestionNum = NUM_OF_QUESTIONS) => {
  for (let i = 0; i < totalQuestionNum; i++) {
    localStorage.removeItem(`question_${i + 1}`);
  }
};

const calculateDurationInSec = (start, end) => {
  const startTime = new Date(start);
  const endTime = new Date(end);

  if (!startTime || !endTime || isNaN(startTime) || isNaN(endTime)) return 0;

  return (endTime - startTime) / 1000;
};

const saveData = async (startTime, prize, status) => {
  const device = `mobile`;

  const userInfo = localStorage.getItem('user-info') && JSON.parse(localStorage.getItem('user-info'));

  const startTimeInLocal = localStorage.getItem('start-time') && localStorage.getItem('start-time');
  const endTime = new Date().toLocaleString();

  const startTimeISO = localStorage.getItem('start-time-iso') && localStorage.getItem('start-time-iso');
  const endTimeISO = new Date().toISOString();

  const docRef = doc(db, `participants`, `k:${TORONTO_KIOSK_ID}`, new Date().toDateString(), uuidv4());

  await setDoc(docRef, {
    device,
    userInfo,
    answers: getAllAnswers(),
    correctAnswers: getCorrectAnswers(),
    prize,
    duration: { startTime: startTime ? startTime : startTimeInLocal, endTime },
    durationInSec: calculateDurationInSec(startTimeISO, endTimeISO),
    status,
    createdAt: Timestamp.now(),
  }).catch((err) => console.log(err));
};

export { TORONTO_KIOSK_ID, VANCOUVER_KIOSK_ID, PRIZE_DAILY_LIMIT, getCorrectAnswers, removeAllAnswers, saveData };
